import { JobBlock as HygraphJobBlock, JobBlockDisplayType } from '@/lib/types';

import { JobBlocksProps, JobBlocksVariant } from '@/features/job-blocks';
import { Job } from '@/services/public-jobs.service';

const variantMap: Record<
  HygraphJobBlock['jobBlockDisplayType'],
  JobBlocksProps['variant']
> = {
  [JobBlockDisplayType.Locations]: JobBlocksVariant.LOCATIONS,
  [JobBlockDisplayType.HighPayingJobs]: JobBlocksVariant.HIGH_PAYING_JOBS,
  [JobBlockDisplayType.CardCarousel]: JobBlocksVariant.CARD_CAROUSEL,
};

export default function jobBlocksTransformer(
  props: HygraphJobBlock,
  jobs?: Job[]
): JobBlocksProps {
  const variant = variantMap[props.jobBlockDisplayType];
  if (variant === JobBlocksVariant.CARD_CAROUSEL) {
    return {
      id: props.id,
      variant,
      discipline: props.specialty?.discipline || props.discipline || undefined,
      specialty: props.specialty || undefined,
      jobs: jobs || [],
    };
  }

  if (variant === JobBlocksVariant.HIGH_PAYING_JOBS) {
    return {
      id: props.id,
      variant,
    };
  }

  // variant === JobBlocksVariant.LOCATIONS
  return {
    id: props.id,
    variant,
  };
}
